const n = {
  name: "Indonesia",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 2H4.48092L4.78117 2.37568C8.48083 7.00477 15.5192 7.00477 19.2188 2.37568L19.5191 2H22V13H19.7237L16.7299 22H14.6099L15.9432 18H13V22H11V18H8.05647L9.3898 22H7.27981L4.27671 13H2V2ZM7.38981 16H11V13H6.38981L7.38981 16ZM13 16H16.6099L17.6099 13H13V16ZM20 11V4.50548C15.6197 8.96151 8.38031 8.96151 4 4.50548V11H20Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as Indonesia
};
